import { CODEDIFINITION_STORAGE } from "03CommonApiParts/CodeDefinition";
import { CFArrayFount } from "03CommonApiParts/CommonFunction";


export const AllItemConfig = (master,getValues,setValue,setError,clearErrors,disabledDep,setDisabledDep,employmentStatusList,outputFields,move) =>{
	/* CODEDIFINITION_STORAGEからコード定義を取得 */
	const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
	var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
	const extractionDepartmentTargetCode = CFArrayFount(codeDefinitionValue,'code','extractionDepartmentTargetCode');

	/* ---------------------------------------------------- */
    /* --------------------- function --------------------- */
    /* ---------------------------------------------------- */
	/* ====== 部署のバリデーション ====== */
	const departmentValidate = () =>{
		const data = getValues('payload3')
		let result = false;
		if(data.etrDptTrgCd === 'allDepartment'){
			clearErrors('payload3.error');
		}else{
			const list = ['department1','department2','department3','department4'];
			list.forEach((item)=>{
				if(data[item]){
					result = true;
				};
			});
			if(result){
				clearErrors('payload3.error')
			}else{
				setError('payload3.error', {type:'custom',message:'必須'})
			};
		}
		
	};

	/* ====== 出力対象をクリックしたときの処理 ====== */
	const onClickOutputTarget = (e, index, fields) => {
		/* 最初にfalseになっている場所を特定 */
		var falseIndex = outputFields.findIndex((row) => row.outputTarget === false);
		/* 最後にtrueになっている場所を特定 */
		var trueIndex = -1;
		outputFields.forEach((item,index)=>{
			if(item.outputTarget === true){
				trueIndex = index;
			};
		});
		/* trueが一つもない時に、checkがtrueになったらエラークリア */
		if(trueIndex === -1 && e.target.checked){
			clearErrors('payload4.error');
		}
		/* 全てtrueの時はfieldのlengthを代入 */
		if(falseIndex < 0){
			falseIndex = outputFields.length;
		};
		var checkIndex = outputFields.findIndex((row) => row.outputTargetId === fields.outputTargetId);
		if(e.target.checked){
			move(checkIndex,falseIndex);
			setValue(`payload4.list.${falseIndex}.number`,falseIndex+1);
		}else{
			move(checkIndex,trueIndex);
			setValue(`payload4.list.${trueIndex}.number`,'ー');
			const data = getValues('payload4.list');
			const editData = [...data];
			data.forEach((row,index)=>{
				if(row.outputTarget){
					editData[index].number = index + 1;
				};
			});
		};
	};

	/* ====== 出力対象(全チェック)のバリデーション ====== */
	const checkAllValidate = () =>{
		const data = getValues('payload4')
		const index = data.list.findIndex((item)=>item.outputTarget === true);
		if(index === -1){
			setError('payload4.error', {type:'custom',message:'必須'})
		}else{
			clearErrors('payload4.error')
		}
	};
	/* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
	/* ====== 出力名のテーブルのデータ ====== */
	const outputNameTableConfig = 
	[
		{
			id:'row1', 
			label:'出力名', 
			required:true,
			list:[
				{name:'dataOtpName',type:'input', maxLength:20, width:'300px', placeholder:'20文字まで',required:true, pattern: 'space'},
			]
		}
	];
	/* ====== 出力名のテーブルの確認用データ ====== */
	/* 出力名のテーブルのデータのコピー(階層が深いのでこの形式) */
	const cnfOutputNameTableConfig = JSON.parse(JSON.stringify(outputNameTableConfig));
	/* 必須マークをfalseに変更 */
	cnfOutputNameTableConfig[0].required = false;
	/* typeをラベルに変更 */
	cnfOutputNameTableConfig[0].list[0].type = 'label';


	/* ====== 抽出条件(雇用形態)テーブルのデータ ====== */
	const empiSttsTableConfig = [
		{
			id: 'row2',
			name: "empiSttsCd",
			label: '雇用形態',
			width: '700px',
			gap: '15px',
			fullWidth: true,
			required: true,
			list:employmentStatusList
		},
	];
	/* ====== 抽出条件(雇用形態)テーブルの確認用データ ====== */
	/* 抽出条件(雇用形態)テーブルのデータのコピー */
	const cnfEmpiSttsTableConfig = JSON.parse(JSON.stringify(empiSttsTableConfig));
	/* 必須マークをfalseに変更 */
	cnfEmpiSttsTableConfig[0].required = false;
	/* 項目をdisabledに変更 */
	cnfEmpiSttsTableConfig[0].list = employmentStatusList.map((item)=>({...item,disabled:true}));

	/* ====== 抽出条件(部署)テーブルのデータ ====== */
	const deptTableConfig = [
		{
			id: 'row3',
			label: '部署\n※最大4部署まで追加可',
			fullWidth: true,
			required: true,
			list: [
				{ name: 'etrDptTrgCd', type: 'radioButton', width: '700px', master:extractionDepartmentTargetCode, defaultChecked: "allDepartment",func: (event) => {
					if(event === 'allDepartment'){
						setValue('payload3.department1', ''); 
						setValue('payload3.department2', ''); 
						setValue('payload3.department3', '');  
						setValue('payload3.department4', '');  
						clearErrors('payload3.error');
						setDisabledDep(true);
					}else{
						setDisabledDep(false);
					}
					; 
					return;
				}},
				{ name: 'department1', type: 'inputList', width: '700px', maxLength: 128, placeholder: '最大128文字',master:master.departmentMaster, fullWidth: true, disabled: disabledDep, validate:departmentValidate},
				{ name: 'department2', type: 'inputList', width: '700px', maxLength: 128, placeholder: '最大128文字',master:master.departmentMaster, fullWidth: true, disabled: disabledDep, validate:departmentValidate},
				{ name: 'department3', type: 'inputList', width: '700px', maxLength: 128, placeholder: '最大128文字',master:master.departmentMaster, fullWidth: true, disabled: disabledDep, validate:departmentValidate},
				{ name: 'department4', type: 'inputList', width: '700px', maxLength: 128, placeholder: '最大128文字',master:master.departmentMaster, fullWidth: true, disabled: disabledDep, validate:departmentValidate},
				{ name:'error',type:'error', style: {marginBottom: "8px"}},
			]
		},
	]

	/* ====== 抽出条件(部署)テーブルの確認データ ====== */
	/* 抽出条件(部署)テーブルのデータをコピー */
	const cnfDeptTableConfig = JSON.parse(JSON.stringify(deptTableConfig));
	/* 必須マークをfalseに変更 */
	cnfDeptTableConfig[0].required = false;
	/* inputListはlabelに変更しそれ以外は、disableをtrueにする */
	cnfDeptTableConfig[0].list = deptTableConfig[0].list.map((item)=>(item.type === 'inputList' ? {...item,type:'label'}:{...item,disabled:true}));

	/* ====== LeftTitleテーブルの設定 ====== */
    //id:idを指定
    //label:左側に表示するタイトル*
    //list:右側に表示するコンテンツのリスト *
    //name:項目名
    //name2:項目名(type:categoryLabelを選択時のみ指定　minorCategory)
    //title:inputなどの隣に表示するタイトル
    //type:表示タイプ label/input/select/date/datetime/categoryLabel(問合せ情報問合せ種別用) *
    //rightLabel:inputなどの隣に表示するラベル 例：メールドメインなど
    //disable:変更不可にする true/false
    //readOnly:ラベル風にする　true/false（select/date/datetime)
    //width:幅の変更をする(inputのみ)


    /* ====== 選択項目テーブルヘッダーを定義 ====== */
    const chooseItemHeadData = [
        { id: 'outputTarget', align: 'center', width: '90px',label1: '出力対象', check: true, checkId:'target', required:true, validate:checkAllValidate},//〇〇データ
        { id: 'outputTargetLabel', align: 'left', width: '225px',  sortTable: false, label1: '項目名'},//〇〇データ
        { id: 'number', align: 'left', width: '80px', sortTable: false, label1: '出力順' },//〇〇データ
    ];

	/* ====== 確認用選択項目テーブルヘッダーを定義 ====== */
	const cnfChooseItemHeadData = JSON.parse(JSON.stringify(chooseItemHeadData));
	cnfChooseItemHeadData[0].disabled = true; 

    /*====== BodyCellの設定 ======*/
    // name         : 項目名
    // name2        : 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align        : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize     : 文字の大きさ デフォルトは12px *label,labelNum
    // color        : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value        : btnFuncで受け取りたい値 *button,iconButton

    /* ====== 選択項目テーブルデータを定義 ====== */
    const chooseItemBodyData = [
		{ name: 'outputTarget', type: 'check', align: 'center', func: onClickOutputTarget},
        { name: 'outputTargetLabel', type: 'label', align: 'left',},
        { name: 'number', type: 'label', align: 'left' },
    ];
	/* ====== 確認用選択項目テーブルヘッダーを定義 ====== */
	const cnfChooseItemBodyData = JSON.parse(JSON.stringify(chooseItemBodyData));
	cnfChooseItemBodyData[0].disabled = true; 

	return{
		outputNameTableConfig,
		cnfOutputNameTableConfig,
		empiSttsTableConfig,
		cnfEmpiSttsTableConfig,
		deptTableConfig,
		cnfDeptTableConfig,
		chooseItemHeadData,
		cnfChooseItemHeadData,
		chooseItemBodyData,
		cnfChooseItemBodyData
	};
}